var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"numerai_info_bubble numerai-paper alert_container py-4 px-4 mb-3"},[_c('div',[_c('div',{staticClass:"alert_title text_weight_600 color-primary"},[_vm._t("title")],2),_c('div',{staticClass:"body mb-1"},[_vm._t("body")],2)]),_c('div',{staticClass:"action_button_container"},[_vm._t("action")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }